module.exports = __webpack_public_path__ + "img/img.3a106ada.png";